import { ApiClientBase } from '../base/api-client-base.ts';
import Endpoints from '../endpoints';
import type {
  IAuthApi,
  RegisterParams,
  RegisterResponse,
  QuickRegisterParams,
  QuickRegisterResponse,
  LoginParams,
  LoginResponse,
  GoogleAuthParams,
  GoogleAuthResponse,
  VerifyEmailParams,
  VerifyEmailResponse,
  ForgotPasswordParams,
  ForgotPasswordResponse,
  ResetPasswordParams,
  ResetPasswordResponse,
  RefreshTokenParams,
  RefreshTokenResponse,
} from './auth.types';

export class AuthApi extends ApiClientBase implements IAuthApi {
  public readonly register = async (
    params: RegisterParams
  ): Promise<RegisterResponse['data']> => {
    const url = Endpoints.Auth.register();
    const response = await this.asyncRunner(() =>
      this.api.post<RegisterResponse>(url, params)
    );
    return response.data.data;
  };

  public readonly quickRegister = async (
    params: QuickRegisterParams
  ): Promise<QuickRegisterResponse['data']> => {
    const url = Endpoints.Auth.quickRegister();
    const response = await this.asyncRunner(() =>
      this.api.post<QuickRegisterResponse>(url, params)
    );
    return response.data.data;
  };

  public readonly login = async (
    params: LoginParams
  ): Promise<LoginResponse['data']> => {
    const url = Endpoints.Auth.login();
    const response = await this.asyncRunner(() =>
      this.api.post<LoginResponse>(url, params)
    );
    return response.data.data;
  };

  public readonly googleAuth = async (
    params: GoogleAuthParams
  ): Promise<GoogleAuthResponse['data']> => {
    const url = Endpoints.Auth.google();
    const response = await this.asyncRunner(() =>
      this.api.post<GoogleAuthResponse>(url, params, {
        withCredentials: true,
      })
    );
    return response.data.data;
  };

  public readonly verifyEmail = async (
    params: VerifyEmailParams
  ): Promise<VerifyEmailResponse> => {
    const url = Endpoints.Auth.verifyEmail();
    const response = await this.asyncRunner(() =>
      this.api.post<VerifyEmailResponse>(url, params)
    );
    return response.data;
  };

  public readonly forgotPassword = async (
    params: ForgotPasswordParams
  ): Promise<ForgotPasswordResponse> => {
    const url = Endpoints.Auth.forgotPassword();
    const response = await this.asyncRunner(() =>
      this.api.post<ForgotPasswordResponse>(url, params)
    );
    return response.data;
  };

  public readonly resetPassword = async (
    params: ResetPasswordParams
  ): Promise<ResetPasswordResponse> => {
    const url = Endpoints.Auth.resetPassword();
    const response = await this.asyncRunner(() =>
      this.api.post<ResetPasswordResponse>(url, params)
    );
    return response.data;
  };

  public readonly refreshToken = async (
    params: RefreshTokenParams
  ): Promise<RefreshTokenResponse['data']> => {
    const url = Endpoints.Auth.refresh();
    const response = await this.asyncRunner(() =>
      this.api.post<RefreshTokenResponse>(url, params)
    );
    return response.data.data;
  };
}
